import React from 'react'
import { LeaderShipTeamDto } from '../../../api/Dtos/profileDto'
import { getServiceyName } from '../../../utility/RolesUtility'
import ReadMore from './ReadMore'
interface infoData {
    submittedData:any
  }
const LeaderShipTeam:React.FC<infoData>=({submittedData})=> {
  return (
    <>
    {submittedData?.leaderShipTeamDtos && submittedData?.leaderShipTeamDtos?.length >0 &&
    <div className="bg-white mb-8 p-5 px-8 mt-5">
          {submittedData?.leaderShipTeamDtos && submittedData?.leaderShipTeamDtos?.length >0 &&
          <p className=" font-bold text-2xl text-primary-color pt-5 border-b pb-4 border-b-gray-200">
            Leadership Team
          </p>
}
          <div className="grid grid-cols-2 gap-8 pt-6 pb-6">
          {submittedData?.leaderShipTeamDtos?.map((item:LeaderShipTeamDto, index:number) => (
            <div className="font-sans border border-gray-200 rounded-lg py-4 pl-4 w-full ">
              <div className="flex gap-5">
                <img src={item?.fileDto?.documentUrl ||'/images/dummpComapnyLogo.svg'} className="size-[180px] rounded-[4px] object-cover" />
              
                <div className="font-sans">
                  {
                    item?.name &&
                  
                  <p className="font-bold text-[18px] text-gray-900 mb-0">
                    {item?.name || 'NA'}
                  </p>}
                  {item?.designation &&
                  <p className="font-normal text-sm text-gray-600 pt-1">
                    {item?.designation || 'NA'}
                  </p>}
                  {item?.gender &&
                  <p className="font-semibold text-sm text-gray-700 pt-1">
                    {getServiceyName(item?.gender) || 'NA'}
                  </p>}
                  {item?.address  &&
                  <div className="pt-2.5 pr-2">
                 
                    <div className="flex font-semibold text-sm text-gray-700 gap-2 items-center cursor-pointer">
                      <img src="/images/location_icon.svg" />
                      <p className=" line-clamp-2">{item?.address || 'NA'}</p>
                    </div>
                  </div>}
                </div>
              </div>
              {item?.bio && (
  <div className="pt-7 font-Inter text-sm pr-2">
    <ReadMore text={item?.bio || "NA"} lines={2} />
  </div>
)}

            </div>))}
           
          </div>
          </div>
}
          </>
  )
}

export default LeaderShipTeam
